import React from 'react';

import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../shared/providers';
import { InfoBox } from '../../../shared/components/ui-components';
import { NotificationsSettingsItem } from './NotificationsSettingsItem/NotificationsSettingsItem';
import { whatsNewStore } from '../../store/whatsNewStore';
import { challengeTutorialStore } from '../../store/challengeTutorialStore';
import { solutionsStore } from '../../../shared/stores/solutionsStore';

const NgzNotificationsSettings = observer(() => {
  const { activeSolutionFlags } = solutionsStore;

  return (
    <InfoBox title="Notifications" customContentPadding>
      {activeSolutionFlags.CHALLENGE && (
        <NotificationsSettingsItem
          title="Turn on challenge tutorial"
          description="The challenge tutorial will appear each time when you're opening the dashboard."
          checked={challengeTutorialStore.showAgain}
          onChange={(showAgain) => challengeTutorialStore.changeShowAgain(showAgain)}
          extraActionTitle="Watch Tutorial Video"
          onExtraAction={() => challengeTutorialStore.openModal('VIEW')}
        />
      )}
      <NotificationsSettingsItem
        title="Important Updates & Features"
        description="Displays notifications about new releases, feature updates, and improvements."
        checked
        switchDisabled
        extraActionTitle="Open Current Updates"
        onExtraAction={whatsNewStore.openModal}
      />
    </InfoBox>
  );
});

angularizeWithProviders(NgzNotificationsSettings, 'ngzNotificationsSettings', {});
